// src/App.js - Enhanced version
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import { ClassroomProvider } from './contexts/ClassroomContext';
import { DeviceProvider } from './contexts/DeviceContext';
import { AuthProvider } from './contexts/AuthContext';
import LandingPage from './components/LandingPage';
import ClassSetup from './components/setup/ClassSetup';
import TeacherDashboard from './components/classroom/TeacherDashboard';
import StudentView from './components/student/StudentView';
import ClassManagement from './components/management/ClassManagement';
import MemberManagement from './components/management/MemberManagement';
import SettingsPanel from './components/settings/SettingsPanel';
import './App.css';
import './styles/scaling.css';

const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

function App() {
  const [deviceType, setDeviceType] = useState('desktop');

  useEffect(() => {
    const detectDevice = () => {
      const width = window.innerWidth;
      if (width <= 768) setDeviceType('mobile');
      else if (width <= 1024) setDeviceType('tablet');
      else setDeviceType('desktop');
    };

    detectDevice();
    window.addEventListener('resize', detectDevice);
    return () => window.removeEventListener('resize', detectDevice);
  }, []);

  const backend = isTouchDevice() ? TouchBackend : HTML5Backend;

  return (
    <DndProvider backend={backend}>
      <DeviceProvider deviceType={deviceType}>
        <AuthProvider>
          <ClassroomProvider>
            <Router>
              <div className="App">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/setup" element={<ClassSetup />} />
                  <Route path="/classroom/:roomId" element={<TeacherDashboard />} />
                  <Route path="/student/:roomId" element={<StudentView />} />
                  <Route path="/manage" element={<ClassManagement />} />
                  <Route path="/members/:classId" element={<MemberManagement />} />
                  <Route path="/settings" element={<SettingsPanel />} />
                </Routes>
              </div>
            </Router>
          </ClassroomProvider>
        </AuthProvider>
      </DeviceProvider>
    </DndProvider>
  );
}

export default App;